import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

document.title = 'MRM AAMPL';
const _backend = process.env.REACT_APP_BACKEND_URL || '';
if (_backend) {
  let _icon = document.querySelector("link[rel~='icon']");
  if (!_icon) { _icon = document.createElement('link'); _icon.rel = 'icon'; document.head.appendChild(_icon); }
  _icon.href = `${_backend}/api/settings/logo`;
  _icon.type = 'image/jpeg';
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
